import { changeMerchant } from '../redux/workspace/actions';
import { getStoreRef } from '../redux/storeRef';
import merchantApi from '../services/general/Merchant';
import { getCurrentMerchant } from './WorkspaceHelper';

const hasSystemSource = (systemSource) =>
	systemSource !== null && systemSource !== undefined;

const systemGateway = (systemSource) => {
	if (String(systemSource) === '1') {
		return 'falcon-mgt';
	}
	// if (String(systemSource) === '0') {
	return 'eagle-mgt';
	// }
	// throw new Error('Invalid system source');
};

const systemSourceUrl = (systemSource, path) => {
	return `/gateway/${systemGateway(systemSource)}${path}`;
};
const resolveSystemSource = async (merchant = getCurrentMerchant()) => {
	if (hasSystemSource(merchant.systemSource)) return merchant.systemSource;
	if (!merchant?.merchantId) {
		throw new Error('merchantId is missing');
	}
	const profile = await merchantApi.profile(merchant.merchantId);

	if (!hasSystemSource(profile.systemSource)) {
		throw new Error('systemSource is missing');
	}
	const store = getStoreRef();
	store.dispatch(
		changeMerchant({
			...merchant,
			systemSource: profile.systemSource,
		})
	);
	return profile.systemSource;
};

export { hasSystemSource, resolveSystemSource, systemGateway, systemSourceUrl };
